<template>
  <div class="general-wrapper">
    <div class="header">
      <h2 class="qrw-heading-xl">{{ $t('stats.title') }}</h2>
    </div>
    <div class="stat-head px-50" v-if="busy">
      <h2 class="c-white">{{ $t('stats.loading') }}</h2>
    </div>
    <div class="px-50" v-else-if="!busy && isStatsNonEmpty">
      <GeneralInfo :values="monthly_summary" :previous="monthly_previous_summary" />
      <div class="space-top row">
        <StatsBarChart
          @changeTab="t => general_tab = t"
          @changeRange="onGeneralChangeRange"
          :currentTab="general_tab"
          :hideActivityTab="true"
        />

        <div class="chart-wrapper">
          <CorporateIncomeGraph 
            :cafes="cafesForStats" 
            :datasets="datasets"
            :colors="graphColors"
            v-if="general_tab == 'income'"/>

          <IncomeStatsPanel
            :stats="monthly_summary"
            :colors="graphColors"
            :cafes="cafesForStats"
            :in_corporate="true"
            v-if="general_tab == 'income'"
          />
        </div>
      </div>
      <!-- <div class="row space-top">
      <RatioSystems :counts="system_ratios" class="right-space" />
    
      <TopStatsList :waiters="top_waiters" :clients="top_clients" :dishes="top_dishes"/>
      </div> -->
        <!-- <PopularDishes /> -->
      <!-- <div class="space-top" v-for="(cafe,index) in cafesForStats" :key="cafe._id">
        <h3 class="c-white">{{cafe.name}}</h3>

        <GeneralInfo :values="monthly[index].total" :previous="monthly_previous[index].total" />

        <StatsBarChart
          @changeTab="t=> changeTab(index, t)"
          @changeRange="onGeneralChangeRange"
          :currentTab="tabs[index]"
        />

        <div class="chart-wrapper">
          <BasicGraph
            :dataset="datasets[cafe._id]"
            :color="graphColors[index % graphColors.length]"
            v-if="tabs[index] == 'income'"
          />

          <VisitsGraph
            v-if="tabs[index] == 'activity'"
            :color="graphColors[index % graphColors.length]"
            :dataset="datasets[cafe._id]"
          />

          <IncomeStatsPanel
            :stats="summaries[cafe._id]"
            :in_corporate="true"
            v-if="tabs[index] == 'income'"
          />
          <ActivityStatsPanel
            :summary="summaries[cafe._id]"
            :in_corporate="true"
            v-if="tabs[index] == 'activity'"
          />
        </div>
      </div> -->
    </div>
    <div class="stats-wrapper px-50" v-else>
      <IQOS :hideTitle="false" class="iqos-empty">
        <p class="comment pt-0 c-white">{{ $t('stats.empty_desc')}}</p>
      </IQOS>
    </div>
  </div>
</template>

<script>
import GeneralInfo from "@/components/stats/GeneralInfo.vue";
import RatioSystems from "@/components/stats/RatioSystems.vue";
import PopularDishes from "@/components/stats/PopularDishes.vue";

import BasicGraph from "@/components/stats/BasicGraph.vue";

import StatsBarChart from "@/components/stats/StatsBarChart.vue";

import IncomeStatsPanel from "@/components/stats/IncomeStatsPanel.vue";

import ActivityStatsPanel from "@/components/stats/ActivityStatsPanel.vue";
import CorporateIncomeGraph from "@/components/stats/CorporateIncomeGraph.vue";
import TopStatsList from "@/components/stats/TopStatsList.vue";

import VisitsGraph from "@/components/stats/VisitsGraph.vue";

import IQOS from "@/components/IQOS.vue";

import StatsAPI from "@/api/stats";

import moment from "moment";

export default {
  data() {
    return {
      monthly: [],
      monthly_previous: [],

      monthly_summary: {},
      monthly_previous_summary: {},

      system_ratios: {
        inside: 0,
        delivery: 0,
        preorder: 0,
      },

      top_waiters: [],
      top_clients: [],
      top_dishes: [],

      graphColors: ["#CBD9E6", "#129B81", "#FFD2A8"],

      tabs: [],
      general_tab: "income",

      range: {
        start: moment().subtract(1, "week").startOf("day").valueOf(),
        end: moment().endOf("day").valueOf(),
      },

      datasets: {},
      summaries: {},

      busy: true,
      busy_count: 0,
    };
  },
  methods: {
    fetchStats() {
      if (!this.isStatsNonEmpty) {
        this.busy = false;
        return;
      }

      this.fetchMonthly();
      this.fetchMonthly(true);
      this.fetchTops();

      this.tabs = this.cafesForStats.map((c) => "income");

      this.cafesForStats.forEach((c) => {
        this.fetchCafeDatasets(c._id);
      });
    },
    atomicIncrementBusy() {
      this.busy_count++;
      if (this.busy_count >= 2 + this.cafesForStats.length) {
        this.busy = false;
      }
    },
    fetchTops() {
      Promise.all(
        [
          StatsAPI.getTopWaiters(this.cafesForStats[0]._id),
          StatsAPI.getTopClients(this.cafesForStats[0]._id),
          StatsAPI.getTopDishes(this.cafesForStats[0]._id)
        ]
      ).then(results => {
        this.top_waiters = results[0].top_waiters;
        this.top_clients = results[1].top_clients;
        this.top_dishes = results[2].top_dishes.map(p => p.name);
      }).catch(error => {
        
      });
    },
    fetchCafeDatasets(cafe_id) {
      Promise.all([
        StatsAPI.getForMode(
          cafe_id,
          "inside",
          this.range.start,
          this.range.end
        ),
        StatsAPI.getForMode(
          cafe_id,
          "preorder",
          this.range.start,
          this.range.end
        ),
        StatsAPI.getForMode(
          cafe_id,
          "delivery",
          this.range.start,
          this.range.end
        ),
      ]).then((results) => {
        const inside = results[0].stats;
        const preorder = results[1].stats;
        const delivery = results[2].stats;

        const cafe_dataset = inside.dataset.map((item, index) => {
          let compound = {
            timestamp: item.timestamp,
            income:
              item.income +
              preorder.dataset[index].income +
              delivery.dataset[index].income,
            visits:
              item.visits +
              preorder.dataset[index].visits +
              delivery.dataset[index].visits,
            orders:
              item.orders +
              preorder.dataset[index].orders +
              delivery.dataset[index].orders,
          };

          return compound;
        });

        const summary_reducer = (key) => (acc, item) =>
          acc + item.stats.summary[key];

        const cafe_summary = {
          income: results.reduce(summary_reducer("income"), 0),
          average: results.reduce(summary_reducer("average"), 0),
          orders: results.reduce(summary_reducer("orders"), 0),
          visits: results.reduce(summary_reducer("visits"), 0),
          bounce: results.reduce(summary_reducer("bounce"), 0),
        };

        cafe_summary.average = Math.round(
          cafe_summary.income / cafe_summary.orders
        );

        cafe_summary.bounce = Math.round(cafe_summary.bounce / results.length);

        this.$set(this.datasets, cafe_id, cafe_dataset);
        this.$set(this.summaries, cafe_id, cafe_summary);
        this.atomicIncrementBusy();
      });
    },
    fetchMonthly(previous) {
      //this array contains promise for each cafe
      let promises = [];

      this.cafesForStats.map((cafe) => {
        promises.push(StatsAPI.getMonthly(cafe._id, previous || false));
      });

      Promise.all(promises).then((results) => {
        let monthly = results.map((r) => r.monthly);

        //Calculte current month system ratios
        if (!previous)
          monthly.map((m) => {
            this.system_ratios.inside += m.inside.orders;
            this.system_ratios.preorder += m.preorder.orders;
            this.system_ratios.delivery += m.delivery.orders;
          });

        if (previous) {
          this.monthly_previous = monthly;
        } else {
          this.monthly = monthly;
        }

        //Calculate general monthly total for all cafes by reducing monthly array

        const reduced = monthly
          .map((m) => m.total)
          .reduce(
            (acc, item) => {
              return {
                average: acc.average + item.average,
                income: acc.income + item.income,
                bounce: acc.bounce + item.bounce,
                orders: acc.orders + item.orders,
                visits: acc.visits + item.visits,
              };
            },
            {
              average: 0,
              income: 0,
              bounce: 0,
              orders: 0,
              visits: 0,
            }
          );

        reduced.average = Math.round(reduced.average / monthly.length);

        reduced.bounce = Math.round(reduced.bounce / monthly.length);

        if (previous) {
          this.monthly_previous_summary = reduced;
        } else {
          this.monthly_summary = reduced;
        }

        this.atomicIncrementBusy();
      });
    },
    changeTab(index, tab) {
      this.$set(this.tabs, index, tab);
    },
    parseStringRange(new_range) {
      let range = {
        start: null,
        end: null,
      };

      if (new_range == "week") {
        range.start = moment().subtract(7, "days").valueOf();
        range.end = moment().endOf("day").valueOf();
      } else if (new_range == "two_weeks") {
        range.start = moment().subtract(14, "days").startOf("day").valueOf();
        range.end = moment().endOf("day").valueOf();
      } else if (new_range == "month") {
        range.start = moment().subtract(30, "days").valueOf();
        range.end = moment().endOf("day").valueOf();
      }

      return Object.assign({}, range);
    },
    onGeneralChangeRange(new_range) {
      const range = this.parseStringRange(new_range);

      this.range = range;

      this.cafesForStats.forEach((c) => {
        this.fetchCafeDatasets(c._id);
      });

      this.fetchMonthly();
      this.fetchMonthly(true);
      this.fetchTops();
    },
  },
  mounted() {
    this.fetchStats();
  },
  computed: {
    cafesForStats() {
      return this.$store.state.corporate_cafes.filter((c) => {
        const then = moment(c.registered);

        return moment().diff(then, "days") > 7;
      });
    },
    isStatsNonEmpty() {
      return !!this.cafesForStats.length;
    },
  },
  components: {
    GeneralInfo,
    RatioSystems,
    PopularDishes,
    IQOS,
    BasicGraph,
    StatsBarChart,
    IncomeStatsPanel,
    ActivityStatsPanel,
    VisitsGraph,
    CorporateIncomeGraph,
    TopStatsList
  },
};
</script>

<style scoped>
.chart-wrapper {
  width: 117vh;
  display: flex;
}
</style>